import { Component, inject } from '@angular/core';

import { MODAL_ANIMATIONS } from '@shared/animations/modal.animation';
import { ButtonComponent } from '@shared/components/button/button.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';

@Component({
  animations: MODAL_ANIMATIONS,
  imports: [IconComponent, ButtonComponent],
  templateUrl: './change-effective-date-modal.component.html',
})
export class ChangeEffectiveDateModalComponent {
  public ref = inject(CustomOverlayRef);

  header = 'Updating Site Budget Effective Date';

  closeModal() {
    this.ref.close({ success: false });
  }
}
